import Web3 from "web3";
export const connectAcc = async (openConnectModal) => {
	try{
    const web3 = new Web3(window.ethereum);
  	const accounts = await web3.eth.getAccounts();
	const account = accounts[0];
  console.log(account);
    if (!account){
      await openConnectModal();
      console.log("open wallet");
    }
    } catch(e){
        console.log(e)
    }
};
